
export default {
  name: 'MegastudioTariffsComparisonTableOptionLineBase',
  props: {
    line: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  methods: {
    toggleVisibleDescription(id) {
      this.isVisible = !this.isVisible
      this.$emit('toggle', { status: this.isVisible, optionId: id })
    },
  },
}
